/**
 * Classe que gerencia as requisições para HoursOfService
 *
 * @author: Adalto Junior DATE: 09/05/2013
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.HoursOfService = Greenmile.HoursOfService || {};

Greenmile.HoursOfService.Requests = function () {

    this.getHosByDriver = function (filter, callback) {

        var error;
        const form = App.Forms.HOS.form;
        
        if (filter.driver.id) {
            form.triggerLoadingBtns();
            try {

                var driverId            = filter.driver.id,
                    urlRetrieveByDriver = 'HOS/retrieveHOSByDriver/' + driverId,
                    hosCollection       = new App.Collections.HoursOfService(),
                    body                = "";

                if (filter.beginDate && filter.endDate) {

                    body = JSON.stringify({ beginDate: filter.beginDate, endDate: filter.endDate });

                }

                const request = new DefaultRequest({
                    url: urlRetrieveByDriver,
                    method: 'post',
                    data: body,
                    success: function (data) {
                        form.triggerLoadingBtns();

                        const dataSerialized = Greenmile.HoursOfService.Utils.mergeHOSByDriver(driverId, data);
                        hosCollection.add(dataSerialized);

                        if (callback) {
                            callback(hosCollection);
                        } else {
                            error = new Monet.Exception.ReturnError(this,
                                "No callback to execute after get HOS by driver.");
                            error.console();
                        }

                    },
                    error: function() {
                        form.triggerLoadingBtns();
                    }
                });
                request.send();

            } catch (e) {
                form.triggerLoadingBtns();
                error = new Monet.Exception.ReturnError(this,
                    "Error on get HOS by driver.", e);
                error.console();
            }

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No driver id to get HOS.");
            error.console();
        }
    };

    this.getHosByRouteAndExecuteCallbak = function (routeId, callback) {

        var error;

        if (routeId) {

            try {

                var urlRetrieveByDriver = 'HOS/retrieveHOSByRoute/' + routeId,
                    hosCollection       = new App.Collections.HoursOfService();

                const request = new DefaultRequest({
                    url: urlRetrieveByDriver,
                    method: "get",
                    success: function (data) {
   
                        const dataSerialized = Greenmile.HoursOfService.Utils.mergeSameDriversHOSByRoute(data);
                        hosCollection.add(dataSerialized);

                        if (callback) {
                            callback(hosCollection);
                        } else {
                            error = new Monet.Exception.ReturnError(this,
                                "No callback to execute after get HOS by route.");
                            error.console();
                        }
                    }
                });
                request.send();

            } catch (e) {
                error = new Monet.Exception.ReturnError(this,
                    "Error on get HOS by route.", e);
                error.console();
            }

        } else {
            error = new Monet.Exception.ReturnError(this,
                "No route id to get HOS.");
            error.console();
        }
    };

};
